export function isAvailable(car: {is_sold: boolean | null}) {
  return !car.is_sold;
}
